/**
 * Admin Auth Hook
 *
 * Hook to access the admin authentication context.
 * Separated from context provider for React Fast Refresh compatibility.
 */

import { useContext } from 'react';
import { AdminAuthContext, type AdminAuthContextType } from '../contexts/adminAuthContextDef';

export const useAdminAuth = (): AdminAuthContextType => {
  const context = useContext(AdminAuthContext);
  if (context === undefined) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return context;
};
